/** Meaning → colour for knowledge bases. One meaning, one colour, wherever it appears.
 *
 *  Imported by the list, the form and the detail view so a STALE badge can never be
 *  amber in one place and red in another. Mirrors `pipeline-status.ts`.
 */
import type { Tone } from '../../components/common/ui-kit';


export const statusTone = (status?: string | null): Tone =>
  (status || '').toUpperCase() === 'ACTIVE' ? 'success' : 'neutral';

export const sourceKindLabel = (kind?: string | null): string => {
  switch (kind) {
    case 'DOCUMENTS': return 'Documents';
    case 'URLS': return 'Web pages';
    case 'MIXED': return 'Mixed';
    default: return '—';
  }
};

/** Bytes as something a person reads. Binary units, because that is what a file
 *  manager shows and a mismatch makes an operator doubt the number. */
export const formatBytes = (bytes?: number | null): string => {
  if (!bytes) return '0 B';
  const units = ['B', 'KB', 'MB', 'GB', 'TB'];
  const i = Math.min(Math.floor(Math.log(bytes) / Math.log(1024)), units.length - 1);
  const value = bytes / 1024 ** i;
  return `${i === 0 ? value : value.toFixed(value < 10 ? 1 : 0)} ${units[i]}`;
};

/** A date an operator can scan, or an em dash. Never "Invalid Date". */
export const formatDate = (iso?: string | null): string => {
  if (!iso) return '—';
  const d = new Date(iso);
  return Number.isNaN(d.getTime())
    ? '—'
    : d.toLocaleDateString(undefined, { day: '2-digit', month: 'short', year: 'numeric' });
};
